import { Weekday } from '../models/Weekday'
import type { WeeklyPeriods } from '../models/WeeklyPeriods'

export function useEmptyWeeklyPeriods (): WeeklyPeriods {
  return {
    [Weekday.Sunday]: [],
    [Weekday.Monday]: [],
    [Weekday.Tuesday]: [],
    [Weekday.Wednesday]: [],
    [Weekday.Thursday]: [],
    [Weekday.Friday]: [],
    [Weekday.Saturday]: []
  }
}
